import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';
import { hideModal } from '../../../actions/modal';
import {
  editProfileData,
  sendOTPMobile,
  updateEmail,
  otpForUpdateEmail,
  verifyOtpForUpdateEmail
} from '../../actions/personalInfo';
import { getFieldsFromDateAsFormat } from '../../../utils/dateFormatter';
import { signout } from '../../../userauth/actions/signinAction';
import { validateEmail, validatePassword } from '../../../utils/inputValidator';
import { isRilDomain } from '../../../utils/common';
import Loader from '../../../components/common/Loader';
import {
  getUaas,
  getAvailableDomainsFlag,
  getFraudReductionForEmployeeCouponsFlag,
  getFraudReductionForEmpCouponsLabels
} from '../../../refresh/selectors/featureFlagsSelector';
import { checkMyJioRedirection } from '../../../refresh/utils/myJioUtils';
import EmailVerify from '../../../refresh/atoms/EmailVerify';
import UserProfileOTPVerification from '../desktop/personal-info-user-otp';

class UpdateEmailIdPopupNewFlow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newEmail: '',
      errEmail: '',
      disableCTA: true,
      showRilEmailMsg: false,
      otp: '',
      secondsRemaining: 60,
      enableResendOTP: false,
      otpSendAgain: false,
      userResend: false,
      otpPopup: false,
      submitRequestBtnDisabledStatus: true
    };
  }

  onClosePopup = () => {
    this.clearIntervalID && clearInterval(this.clearIntervalID);
    this.setState({
      otp: '',
      secondsRemaining: 60,
      enableResendOTP: false,
      otpSendAgain: false,
      userResend: false,
      otpPopup: false,
      submitRequestBtnDisabledStatus: false
    });
    this.props.disableReturnButtonAction(false);
    this.props.clearOtpData();
  };

  submitUserOTP = event => {
    event.preventDefault();
    const { otp, newEmail } = this.state;
    this.props.verifyOtpForUpdateEmail({ otp, emailId: newEmail });
  };

  resendOTP = () => {
    const custProfile = {
      emailId: this.state.newEmail.toLowerCase(),
      mobileNumber: this.props.mobileNumber
    };
    this.props.otpForUpdateEmail(custProfile, () => {
      this.setState({
        secondsRemaining: 60,
        otpValidMessage: ''
      });
      this._decrease();
    });
  };

  _decrease(secLeft) {
    let timer = secLeft || this.state.secondsRemaining;
    if (timer > 0 && !this.state.errorMsg) {
      this.setState({ secondsRemaining: timer - 1 });
      this.local.timeout = setTimeout(this._decrease.bind(this), 1000);
    } else {
      this.local.timeout && clearTimeout(this.local.timeout);
      this.setState({ enableResendOTP: true });
    }
  }

  handleOTPChange = event => {
    this.setState({ ...this.state, otp: event.target.value });
  };

  enterPressed = event => {
    if (event.keyCode === 13 || event.charCode === 13) {
      event.preventDefault();
      const { otp, newEmail } = this.state;
      this.props.verifyOtpForUpdateEmail({ otp, emailId: newEmail });
    }
  };

  handleSubmit = async e => {
    e.preventDefault();
    ga('send', {
      eventCategory: 'buttonTap',
      eventAction: 'Change Personal Info',
      eventLabel: 'Save New Email Address'
    });
    if (this.state.newEmail && validateEmail(this.state.newEmail)) {
      let custProfile = {
        emailAddress: this.state.newEmail.toLowerCase(),
        mobileNumber: this.props.mobileNumber
      };
      // if (this.props.isUaas) {
      //   custProfile = {
      //     emailId: this.state.newEmail.toLowerCase(),
      //     login: this.props?.uid
      //   };
      // }
      this.setState({
        errEmail: ''
      });
      this.props.otpForUpdateEmail(custProfile, () => {
        if (
          this.props.statusCode === 201 ||
          (this.props.isUaas && this.props.statusCode === 200 && this.props.success)
        ) {
          console.log(
            '🚀 ~ file: UpdateEmailIdPopupNewFlow.js:130 ~ UpdateEmailIdPopupNewFlow ~ this.props.otpForUpdateEmail ~ this.props.statusCode === 201:',
            this.props.statusCode === 201
          );
          const {
            personalInfo = [],
            otp_popup_display_mobile,
            otp_popup_display_email
          } = this.props;
          const {
            profile = {},
            otpVerifyResponseObj: { message = '', statusCode = '' } = {}
          } = personalInfo;
          let {
            accountNumber,
            confirmAccountNumber,
            ifscCode,
            refundOption,
            submitRequestBtnDisabledStatus,
            returnFee,
            showReturnFee,
            isChecked,
            otp = '',
            secondsRemaining = '',
            enableResendOTP = '',
            otpSendAgain = false
          } = this.state;
          this.otpLabel = {
            resetBtnTxt: 'Cancel',
            saveBtnTxt: 'SUBMIT',
            otpMsg: 'An OTP will be sent to your registered mobile number',
            otpTitle: 'Bank Transfer OTP',
            otpDescription: 'Please enter OTP sent to'
          };
          // TODO: logout user on update email => Defect id = 186514
          // var signInObj = {};
          // signInObj = {
          //     "username" : this.state.newEmail.toLowerCase(),
          //     "password" : this.state.userPwd,
          //     // "device":  this.props.viewSiteAs || window.device
          // }
          // this.props.login(signInObj, () => { //change emailAddress to username
          //     if(this.props.validUser){
          //     this.setState({
          //         errEmail: "",
          //         errPwd: ""
          //     })

          //     this.props.hideModal("update-email");
          //     window.location.reload();
          //     }
          // });
          this.props.hideModal('update-email');
          <Modal
            name="otp-popup"
            className="user-profile-otp-mob"
            disableOutsideClick
            closeButton
            onClose={this.onClosePopup}
          >
            <UserProfileOTPVerification
              {...this.props}
              otp={otp}
              message={message}
              statusCode={statusCode || 200}
              secondsRemaining={secondsRemaining}
              enableResendOTP={enableResendOTP}
              otpSendAgain={otpSendAgain}
              app="MSITE"
              otp_popup_display_mobile={otp_popup_display_mobile}
              otp_popup_display_email={otp_popup_display_email}
              personalInfo={personalInfo}
              otpTitle={this.otpLabel.otpTitle}
              otpDescription={this.otpLabel.otpDescription}
              otpSubmitBtn="Confirm OTP"
              submitUserOTP={this.submitUserOTP}
              handleOTPChange={this.handleOTPChange}
              resendOTP={this.resendOTP}
              enterPressed={this.enterPressed}
            />
          </Modal>;
          this.props.signout(() => {
            window.location = '/login';
          })();
        } else if (
          this.props.statusCode === 400 ||
          this.props.statusCode === 401 ||
          this.props.statusCode === 403
        ) {
          console.log(
            '🚀 ~ file: UpdateEmailIdPopupNewFlow.js:216 ~ UpdateEmailIdPopupNewFlow ~ this.props.otpForUpdateEmail ~ this.props.statusCode === 400 :',
            this.props.statusCode === 400
          );
          const {
            personalInfo = [],
            otp_popup_display_mobile,
            otp_popup_display_email
          } = this.props;
          const {
            profile = {},
            otpVerifyResponseObj: { message = '', statusCode = '' } = {}
          } = personalInfo;
          let {
            accountNumber,
            confirmAccountNumber,
            ifscCode,
            refundOption,
            submitRequestBtnDisabledStatus,
            returnFee,
            showReturnFee,
            isChecked,
            otp = '',
            secondsRemaining = '',
            enableResendOTP = '',
            otpSendAgain = false
          } = this.state;
          this.otpLabel = {
            resetBtnTxt: 'Cancel',
            saveBtnTxt: 'SUBMIT',
            otpMsg: 'An OTP will be sent to your registered mobile number',
            otpTitle: 'Bank Transfer OTP',
            otpDescription: 'Please enter OTP sent to'
          };
          <Modal
            name="otp-popup"
            className="user-profile-otp-mob"
            disableOutsideClick
            closeButton
            onClose={this.onClosePopup}
          >
            <UserProfileOTPVerification
              {...this.props}
              otp={otp}
              message={message}
              statusCode={statusCode || 200}
              secondsRemaining={secondsRemaining}
              enableResendOTP={enableResendOTP}
              otpSendAgain={otpSendAgain}
              app="MSITE"
              otp_popup_display_mobile={otp_popup_display_mobile}
              otp_popup_display_email={otp_popup_display_email}
              personalInfo={personalInfo}
              otpTitle={this.otpLabel.otpTitle}
              otpDescription={this.otpLabel.otpDescription}
              otpSubmitBtn="Confirm OTP"
              submitUserOTP={this.submitUserOTP}
              handleOTPChange={this.handleOTPChange}
              resendOTP={this.resendOTP}
              enterPressed={this.enterPressed}
            />
          </Modal>;
          if (this.props.type === 'Email Update Error') {
            this.setState({
              errEmail: this.props.message
            });
          }
        }
      });
    } else if (!this.state.newEmail) {
      this.setState({
        errEmail: 'Please enter a new email ID.'
      });
    } else if (!validateEmail(this.state.newEmail)) {
      this.setState({
        errEmail: 'Please enter a valid email address.',
        errPwd: ''
      });
    }
  };

  handleChange(field, value, errmessage = '') {
    const { disableCTA, newEmail, userPwd } = this.state;
    let cta = disableCTA;
    if (field === 'newEmail') {
      value !== '' && this.isRilUser(value);
      errmessage = '';
      if (value !== '' && userPwd !== '') cta = false;
      else cta = true;
    }
    this.setState({
      [field]: value,
      disableCTA: cta
    });
  }

  isRilUser = debounce(value => {
    const { availableDomains } = this.props;
    const isDomainlRil = isRilDomain(availableDomains, value);
    this.setState({ showRilEmailMsg: isDomainlRil });
  }, 1000);

  render() {
    let { error: { errorType = '', message: errmessage = '' } = {} } = this.props.httpError;
    let data = errmessage;
    return (
      <form
        className="update-mobile-form"
        id="updateEmailForm"
        noValidate
        onSubmit={this.handleSubmit}
      >
        <Loader name="mobile-num-popup" />
        <p className="update-mobile-no-text">
          {' '}
          <strong>Enter New Email Address</strong>{' '}
        </p>
        <div className="update-mob-input-field-block">
          <div className="email-id">
            <input
              className="update-mobile-mod-input"
              name="newEmail"
              size="32"
              maxLength="254"
              type="email"
              value={this.state.newEmail}
              onChange={e => {
                this.handleChange('newEmail', e.target.value, data);
              }}
              autoComplete="email"
            />
            <label htmlFor="newEmail" className="newEmailLabel">
              Email Address
            </label>
            {this.state.errEmail && <div className="err-msg-email">{this.state.errEmail}</div>}
            {this.props.fraudReductionForEmployeeCouponsFlag &&
              this.props.isUaas &&
              this.state.showRilEmailMsg && (
                <EmailVerify
                  ctaLabel={this.props.fraudReductionForEmpCouponsLabels?.updateRilEmpTxt}
                  sourceType="EDUCATE"
                />
              )}
          </div>
          <div className="mobaddaddr-type">
            <input
              type="submit"
              disabled={this.state.disableCTA}
              placeholder="save"
              className="update-mobile-mod-verify update-email-popup"
              value="Send OTP for verification"
            />
          </div>
        </div>
      </form>
    );
  }
}
const mapStatetoProps = state => {
  const { personalInfo = {}, signInReducer = {}, httpError = {} } = state;
  const { validUser = false } = signInReducer;
  const { emailUpdate = {}, profile: { screenName = '', uid = '' } = {} } = personalInfo;
  const { statusCode = '', message = '', type = '', success } = emailUpdate;
  const isMyJioRedirection = checkMyJioRedirection();
  const isUaas = getUaas(state) || isMyJioRedirection;
  const fraudReductionForEmployeeCouponsFlag = getFraudReductionForEmployeeCouponsFlag(state);
  const fraudReductionForEmpCouponsLabels = getFraudReductionForEmpCouponsLabels(state);
  const availableDomains = getAvailableDomainsFlag(state);
  return {
    statusCode,
    message,
    type,
    validUser,
    screenName,
    isUaas,
    fraudReductionForEmployeeCouponsFlag,
    fraudReductionForEmpCouponsLabels,
    uid,
    success,
    httpError,
    availableDomains,
    personalInfo
  };
};
const mapDispatchToProps = dispatch => {
  return {
    editProfileData: formData => {
      dispatch(editProfileData(formData));
    },
    updateEmail: (formData, callback) => {
      dispatch(updateEmail(formData, callback));
    },
    otpForUpdateEmail: (formData, callback) => {
      dispatch(otpForUpdateEmail(formData, callback));
    },
    verifyOtpForUpdateEmail: (formData, callback) => {
      dispatch(verifyOtpForUpdateEmail(formData, callback));
    },
    signout: callback => {
      dispatch(signout(callback));
    },
    hideModal: name => {
      dispatch(hideModal(name));
    }
  };
};
export default UpdateEmailIdPopupNewFlow = connect(
  mapStatetoProps,
  mapDispatchToProps
)(UpdateEmailIdPopupNewFlow);
